import React from "react";
import { ArcBox } from "@src/core/ui";
import { ArcInFlightCardProps } from "./types";
import ArcInFlightCardDetails from '@src/features/order/pages/orders-page/components/arc-in-flight-card-details';


const ArcInFlightCard: React.FC<ArcInFlightCardProps> = ({
  order,
  isSelected,
  onClick,
  index,
  drone,
  sx,
}) => {

  return (
    <ArcBox
      key={index}
      p={1.5}
      bgcolor={"grey.900"}
      borderRadius={1}
      sx={{
        cursor: "pointer",
        "&:hover": {
          bgcolor: "grey.800",
        },
        border: "1px solid",
        borderColor: isSelected
          ? "brand.main"
          : "grey.900",
        width: "100%",
        ...sx,
      }}
      onClick={onClick}
    >
      <ArcInFlightCardDetails order={order} drone={drone}/>
    </ArcBox>
  );
};

export default ArcInFlightCard;
